// import { toastify } from "../../../components/ui/Toasts/index.js"; ""

// export const queryClientConfig = {
//     defaultOptions: {
//         queries: {
//             refetchOnMount: false,       
//             refetchOnWindowFocus: false,  
//             refetchOnReconnect: false,
//             staleTime: 0,
//             retry: 0,
//         },
//         mutation: {
//             onError: (error: any) => {
//                 toastify("error", error.message)
//             }
//         }
//     }
// }

import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { showToast } from "../../../App.js";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any, query) => {
      if (error?.message?.includes("نشست شما منقضی")) return;
      showToast("error", error?.message || "خطا در دریافت اطلاعات");
    },
  }),
  mutationCache: new MutationCache({
    onSuccess: (data: any) => {
      if (data?.message) showToast("success", data.message);
    },
    onError: (error: any) => {
      if (error?.message?.includes("نشست شما منقضی")) return;
      showToast("error", error?.message || "خطا در انجام عملیات");
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 0,
      retry: 0,
    },
  },
});